import { el, escape } from './dom';
import { DropZone, type DropZoneProps } from './DropZone';

export type HeroProps = {
  headline?: string;
  lede?: string;
  dropZone?: DropZoneProps;
};

const DEFAULT_HEADLINE = "AI tools don't forget what you paste into them";
const DEFAULT_LEDE =
  "drop a file here first. we strip names, addresses, and numbers — and the hidden metadata you can't see — all in your browser, before the file goes anywhere it can't come back from.";

export const Hero = (props: HeroProps = {}): HTMLElement => {
  const headline = escape(props.headline ?? DEFAULT_HEADLINE);
  const lede = escape(props.lede ?? DEFAULT_LEDE);

  const root = el(`
    <section class="hero">
      <div class="container">
        <h1>${headline}<span class="accent-period">.</span></h1>
        <p class="lede">${lede}</p>
        <div data-slot="drop-zone"></div>
        <div class="hero-utility">
          <span class="hero-utility-item">5 free redactions</span>
          <span class="hero-utility-item">no signup</span>
          <span class="hero-utility-item"><a href="#trust">prove it doesn't upload →</a></span>
          <span class="hero-utility-item hero-utility-aside">processing happens locally</span>
        </div>
      </div>
    </section>
  `);

  const slot = root.querySelector('[data-slot="drop-zone"]');
  slot?.replaceWith(DropZone(props.dropZone ?? {}));
  return root;
};
